import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  partner: null,
};

export const counterSlice = createSlice({
  name: 'partner',
  initialState,
  reducers: {
    setPartner: (state, action) => {
      state.partner = action.payload;
    },
    clearPartner: (state) => {
      state.partner = null;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setPartner, clearPartner } = counterSlice.actions;

export default counterSlice.reducer;
